// extracted by mini-css-extract-plugin
module.exports = {"iotComp":"IotComp_iotComp__YE1fm"};